import userCenter from "@/utils/userCenter";
import to from "@/utils/await-to";
import reqTip from "@/utils/requestTip";

let isPro = process.env.VUE_APP_ENV == "pre" ? true : false;
let ss = sessionStorage;
userCenter.set({
	version: "7.0", // 用户平台版本 6.0/7.0
	isPro: true, // 根据开发环境设置
	loginPlatformCode: ss.loginPlatformCode,
	platformCode: ss.platformCode,
});

// ===============作业管理===========

//获取班级列表
export async function getClassList(params) {
	let req = userCenter.RequestHandler({
		url: "/user/api/org/get-edu-child-list",
		method: "get",
		params,
	});
	const [err, res] = await to(req);
	if (err || !res || res.code != "000000") {
		err ? reqTip.showNetworkError(err) : reqTip.showReqError(res, "获取班级数据异常，请稍后再试");
		return null;
	}
	return res.result.list || [];
}

//获取学科列表
// export async function getSubjectList(data) {
// 	let req = userCenter.RequestHandler({
// 		url: "/user/api/subject/get-school-subject",
// 		method: "post",
// 		data,
// 	});
// 	const [err, res] = await to(req);
// 	if (err || !res || res.code != "000000") {
// 		err ? reqTip.showNetworkError(err) : reqTip.showReqError(res, "获取学科数据异常，请稍后再试");
// 		return null;
// 	}
// 	return res.result.system_list || [];
// }

//获取班级教师列表
// export async function getTeacherList(params) {
// 	let req = userCenter.RequestHandler({
// 		url: "/user/api/org/get-class-teacher-list",
// 		method: "get",
// 		params,
// 	});
// 	const [err, res] = await to(req);
// 	if (err || !res || res.code != "000000") {
// 		err ? reqTip.showNetworkError(err) : reqTip.showReqError(res, "获取教师数据异常，请稍后再试");
// 		return null;
// 	}
// 	return res.result.member_list || [];
// }

//获取学校教师列表
export async function getTeacherList(data) {
	let req = userCenter.RequestHandler({
		url: "/user/api/org/get-school-teacher-list",
		method: "post",
		data,
	});
	const [err, res] = await to(req);
	if (err || !res || res.code != "000000") {
		err ? reqTip.showNetworkError(err) : reqTip.showReqError(res, "获取教师数据异常，请稍后再试");
		return null;
	}
	return res.result.member_list || [];
}
